import { get } from 'api/get';
import { post } from 'api/post';
import { put } from 'api/put';
import { reqDelete } from 'api/req-delete';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const GLOBAL_SETTINGS_SET_GS_ITEM_VALUE = 'GLOBAL_SETTINGS_SET_GS_ITEM_VALUE';
export const SAVE_GLOBAL_SETTINGS_SUCCESS = 'SAVE_GLOBAL_SETTINGS_SUCCESS';
export const SAVE_GLOBAL_SETTINGS_FAILURE = 'SAVE_GLOBAL_SETTINGS_FAILURE';
export const GET_GLOBAL_SETTINGS_SUCCESS = 'GET_GLOBAL_SETTINGS_SUCCESS';
export const GET_GLOBAL_SETTINGS_FAILURE = 'GET_GLOBAL_SETTINGS_FAILURE';

export const GET_GLOBAL_SETTINGS_TERMS_SUCCESS = 'GET_GLOBAL_SETTINGS_TERMS_SUCCESS';
export const GET_GLOBAL_SETTINGS_TERMS_FAILURE = 'GET_GLOBAL_SETTINGS_TERMS_FAILURE';

export const GLOBAL_SETTINGS_DELETE_TERM_SUCCESS = 'GLOBAL_SETTINGS_DELETE_TERM_SUCCESS';
export const GLOBAL_SETTINGS_DELETE_TERM_FAILURE = 'GLOBAL_SETTINGS_DELETE_TERM_FAILURE';

export const SAVE_GLOBAL_SETTINGS_TERMS_SUCCESS = 'SAVE_GLOBAL_SETTINGS_TERMS_SUCCESS';
export const SAVE_GLOBAL_SETTINGS_TERMS_FAILURE = 'SAVE_GLOBAL_SETTINGS_TERMS_FAILURE';

export const GLOBAL_SETTINGS_SET_ITEM_VALUE = 'GLOBAL_SETTINGS_SET_ITEM_VALUE';
export const GLOBAL_SETTINGS_ADD_ITEM = 'GLOBAL_SETTINGS_ADD_ITEM';
export const GLOBAL_SETTINGS_REMOVE_ITEM = 'GLOBAL_SETTINGS_REMOVE_ITEM';
export const GLOBAL_SETTINGS_VALIDATE_ITEMS = 'GLOBAL_SETTINGS_VALIDATE_ITEMS';

export const GLOBAL_SETTINGS_RESET_VALUES = 'GLOBAL_SETTINGS_RESET_VALUES';
export const GLOBAL_SETTINGS_TOGGLE_CONFIRM_MODAL = 'GLOBAL_SETTINGS_TOGGLE_CONFIRM_MODAL';

export const GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS = 'GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS';
export const GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE = 'GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE';

export const SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS = 'SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS';
export const SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE = 'SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE';

export const GENERATE_SUMMARY_REQUEST = 'GENERATE_SUMMARY_REQUEST';
export const GENERATE_SUMMARY_SUCCESS = 'GENERATE_SUMMARY_SUCCESS';
export const GENERATE_SUMMARY_FAILURE = 'GENERATE_SUMMARY_FAILURE';

export const ERROR_GB_TRENDS_REF_DAYS = 'ERROR_GB_TRENDS_REF_DAYS';
export const ERROR_GET_GB_TRENDS_REF_DAYS = 'GET_GLOBAL_SETTINGS_FAILURE';
export const SET_GB_TRENDS_REF_DAYS = 'SET_GB_TRENDS_REF_DAYS';
export const GET_GB_TRENDS_REF_DAYS = 'GET_GB_TRENDS_REF_DAYS';
export const UPDATE_GB_TRENDS_REF_DAYS = 'UPDATE_GB_TRENDS_REF_DAYS';

export const GET_RAR_VALUES = 'GET_RAR_VALUES';
export const ERROR_GET_RAR_VALUES = 'ERROR_GET_RAR_VALUES';
export const SET_RAR_VALUES = 'SET_RAR_VALUES';
export const UPDATE_RAR_VALUES = 'UPDATE_RAR_VALUES';
export const SET_MENU = 'SET_MENU';
export const ERROR_RAR_VALUES = 'ERROR_RAR_VALUES';

export function getRARValues() {
  return async (dispatch) => {
    try {
      const req = await get('par-levels');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_RAR_VALUES,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ERROR_GET_RAR_VALUES,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function toggleConfirmModal(isVisible) {
  return {
    type: GLOBAL_SETTINGS_TOGGLE_CONFIRM_MODAL,
    payload: isVisible
  };
}

export function resetValues() {
  return {
    type: GLOBAL_SETTINGS_RESET_VALUES,
    payload: null
  };
}

export function saveGlobalSettings(data) {
  return async (dispatch) => {
    try {
      await post('global-settings', data);
      dispatch({
        type: SAVE_GLOBAL_SETTINGS_SUCCESS,
        payload: null
      });

      dispatch({
        type: GLOBAL_SETTINGS_RESET_VALUES,
        payload: null
      });

      dispatch(getSettingsList());

      dispatch(appendStatus('Global settings saved successfully.', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SAVE_GLOBAL_SETTINGS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function getSettingsList() {
  return async (dispatch) => {
    try {
      const req = await get('global-settings');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_GLOBAL_SETTINGS_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GET_GLOBAL_SETTINGS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function getGlobalSettingsTerms() {
  return async (dispatch) => {
    try {
      const req = await get('global-settings/terms');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_GLOBAL_SETTINGS_TERMS_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GET_GLOBAL_SETTINGS_TERMS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function deleteTerm(termId, type) {
  return async (dispatch) => {
    let dataToSend = {
      id: parseInt(termId),
      type: type
    };

    try {
      await reqDelete('global-settings/terms', dataToSend);

      dispatch({
        type: GLOBAL_SETTINGS_DELETE_TERM_SUCCESS,
        payload: null
      });

      dispatch(getGlobalSettingsTerms());
      dispatch(appendStatus('Term deleted successfully.', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GLOBAL_SETTINGS_DELETE_TERM_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function saveGlobalSettingsTerms(data) {
  return async (dispatch) => {
    try {
      await post('global-settings/terms', data);

      dispatch({
        type: SAVE_GLOBAL_SETTINGS_TERMS_SUCCESS,
        payload: null
      });

      dispatch({
        type: GLOBAL_SETTINGS_RESET_VALUES,
        payload: null
      });

      dispatch(getGlobalSettingsTerms());
      dispatch(appendStatus('Global settings terms saved successfully.', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SAVE_GLOBAL_SETTINGS_TERMS_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function setItemValue(title, key, id, value) {
  return {
    type: GLOBAL_SETTINGS_SET_ITEM_VALUE,
    payload: {
      id: id,
      title: title,
      key: key,
      value: value
    }
  };
}

export function removeItem(id, key) {
  return async (dispatch) => {
    dispatch({
      type: GLOBAL_SETTINGS_REMOVE_ITEM,
      payload: {
        key: key,
        id: id
      }
    });

    dispatch(getGlobalSettingsTerms());
  };
}

export function addNewItem(key) {
  return {
    type: GLOBAL_SETTINGS_ADD_ITEM,
    payload: key
  };
}

export function validateItems() {
  return {
    type: GLOBAL_SETTINGS_VALIDATE_ITEMS,
    payload: null
  };
}

export function setGSItemValue(key, value) {
  return {
    type: GLOBAL_SETTINGS_SET_GS_ITEM_VALUE,
    payload: {
      key: key,
      value: value
    }
  };
}

export function getGlobalSettingsProductSources() {
  return async (dispatch) => {
    try {
      const req = await get('global-settings/product-sources');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GET_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function saveGlobalSettingsProductSources(data) {
  return async (dispatch) => {
    try {
      await post('global-settings/product-sources', data);

      dispatch({
        type: SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_SUCCESS,
        payload: null
      });

      dispatch({
        type: GLOBAL_SETTINGS_RESET_VALUES,
        payload: null
      });

      dispatch(getGlobalSettingsProductSources());
      dispatch(appendStatus('Global settings product sources saved successfully', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: SAVE_GLOBAL_SETTINGS_PRODUCT_SOURCES_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function generateSummary(data) {
  return async (dispatch) => {
    try {
      dispatch({
        type: GENERATE_SUMMARY_REQUEST,
        payload: {}
      });

      const req = await post('reports/generate-summary-report', data, 'arraybuffer');
      const resp = _.get(req, 'data', []);

      dispatch({
        type: GENERATE_SUMMARY_SUCCESS,
        payload: {
          data: resp
        }
      });

      dispatch(appendStatus('Summary report generated successfully.', 'info'));
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: GENERATE_SUMMARY_FAILURE,
        payload: errPayload
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function GetTrendsInStockRefPeriodDays() {
  return async (dispatch) => {
    try {
      const req = await get('global-settings/trend-ref-period');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: GET_GB_TRENDS_REF_DAYS,
        payload: data
      });
    } catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: ERROR_GET_GB_TRENDS_REF_DAYS,
        payload: errPayload
      });
      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  };
}

export function UpdateTrendsInStockRefPeriodDays(value) {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_GB_TRENDS_REF_DAYS,
        payload: null
      });

      const req = await put('global-settings/trend-ref-period', {
        value: parseInt(value)
      });
      const data = _.get(req, 'data.payload', []);
      dispatch({
        type: ERROR_GB_TRENDS_REF_DAYS,
        payload: data
      });
    } catch (error) {
      console.log(error);
    }
  };
}

export function setGetTrendsInStockRefPeriodDays(value) {
  return {
    type: SET_GB_TRENDS_REF_DAYS,
    payload: {
      value
    }
  };
}

export function setRARTrendsInStockRefPeriodDays(value, id) {
  return {
    type: SET_RAR_VALUES,
    payload: {
      value,
      id
    }
  };
}

export function UpdateRARValues(pdata) {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_RAR_VALUES,
        payload: null
      });

      const req = await post('global-settings-par-levels', pdata);
      const data = _.get(req, 'data.payload', []);
      dispatch({
        type: ERROR_RAR_VALUES,
        payload: data
      });
    } catch (error) {
      console.log(error);
    }
  };
}
